import { render, staticRenderFns } from "./watcher.vue?vue&type=template&id=1cf47efb"
import script from "./watcher.vue?vue&type=script&lang=js"
export * from "./watcher.vue?vue&type=script&lang=js"
import style0 from "./watcher.vue?vue&type=style&index=0&id=1cf47efb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports